import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RECENT_ITEMS_SECTION_ID, CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID } from '@atlassian/search-client';
var MAX_RENDERED_SEARCH_RESULTS = 5;
/**
 * This transformer removes any duplicate from search results and recently viewed items
 */
export var DeduplicateRecentlyViewedAndResultsTransformer = function DeduplicateRecentlyViewedAndResultsTransformer(_ref) {
  var _postQueryItems$secti, _postQueryItems$secti2;
  var preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  var searchResults = ((_postQueryItems$secti = postQueryItems.sections.find(function (section) {
    return section.id === CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID;
  })) === null || _postQueryItems$secti === void 0 ? void 0 : _postQueryItems$secti.searchResults) || [];
  var recentlyViewedResults = ((_postQueryItems$secti2 = postQueryItems.sections.find(function (section) {
    return section.id === RECENT_ITEMS_SECTION_ID;
  })) === null || _postQueryItems$secti2 === void 0 ? void 0 : _postQueryItems$secti2.searchResults) || [];
  var dedupedSearchResults = searchResults.filter(function (searchResult) {
    // Check for duplicates using ARIs
    var isDuplicate = recentlyViewedResults.some(function (recentlyViewedResult) {
      return recentlyViewedResult.ari === searchResult.ari;
    });
    return searchResult.ari && !isDuplicate;
  });
  var postDeduplication = _objectSpread(_objectSpread({}, postQueryItems), {}, {
    sections: postQueryItems.sections.map(function (section) {
      if (section.id === CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID) {
        return _objectSpread(_objectSpread({}, section), {}, {
          searchResults: dedupedSearchResults.slice(0, MAX_RENDERED_SEARCH_RESULTS)
        });
      }
      return section;
    })
  });
  return children({
    preQueryItems: preQueryItems,
    postQueryItems: postDeduplication,
    productState: productState
  });
};